import "./index.css";
import { TrashIcon, ArrowUpIcon, ArrowDownIcon } from "../../../icons";

/** One column row on the label: a printed name field plus its three small controls. */
function Field({ label, index, count, onUpdate, onDelete, onMoveUp, onMoveDown }) {
  const isFirst = index === 0;
  const isLast = index === count - 1;
  return (
    <div className="Field">
      <span className="Field-index" aria-hidden="true">{index + 1}</span>
      <input
        className="Field-input"
        value={label}
        maxLength={24}
        aria-label={`Column ${index + 1} name`}
        onChange={(e) => onUpdate(e.target.value)}
      />
      <div className="Field-actions">
        <button type="button" className="IconButton" onClick={onMoveUp} disabled={isFirst} aria-label={`Move ${label || "column"} up`} title="Move up">
          <ArrowUpIcon />
        </button>
        <button type="button" className="IconButton" onClick={onMoveDown} disabled={isLast} aria-label={`Move ${label || "column"} down`} title="Move down">
          <ArrowDownIcon />
        </button>
        <button type="button" className="IconButton is-danger" onClick={onDelete} disabled={count <= 1} aria-label={`Delete ${label || "column"}`} title="Delete">
          <TrashIcon />
        </button>
      </div>
    </div>
  );
}

export default Field;
